import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';
import AuctionProcess from './AuctionProcess';
import AuctionTerm from './AuctionTerm';
import AuctionForm from './AuctionForm';

const Tabs = [
  { value: 'p', label: '경매절차' },
  { value: 't', label: '경매용어' },
  { value: 'f', label: '경매서식' },
];
const Studyroom = () => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [tab, setTab] = useState('p');

  const param = new URLSearchParams(window.location.search);
  const type = param.get('type');

  useEffect(() => {
    setTab(type || 'p');
  }, [type]);

  const renderContent = () => {
    if (tab === 'p') {
      return <AuctionProcess />;
    }
    if (tab === 't') {
      return <AuctionTerm />;
    }
    if (tab === 'f') {
      return <AuctionForm />;
    }
  };

  return (
    <Container>
      <PageTop text="스터디룸" setOpenMenu={setOpenMenu} />
      <TabBox>
        <TabBoxInner>
          {Tabs.map((item, idx) => (
            <Tab
              key={idx}
              active={tab === item.value}
              onClick={() => {
                setTab(item.value);
                navigate(`/studyroom?type=${item.value}`);
              }}
            >
              {item.label}
            </Tab>
          ))}
        </TabBoxInner>
      </TabBox>
      {renderContent()}
      <Footer />
      {openMenu && <Menu page="myAlgorithmList" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};
export default Studyroom;

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const TabBox = styled.div`
  width: 100%;
  padding-inline: 16px;
  border-bottom: 1px solid #e1e2e4;
  background-color: white;
`;
const TabBoxInner = styled.div`
  display: flex;
  flex-direction: row;
`;
const Tab = styled.button<{ active: boolean }>`
  padding-block: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: ${({ active }) => (active ? '#222' : '#989BA2')};
  border: none;
  border-bottom: ${({ active }) => (active ? '2px solid #222' : 'none')};
  background: none;
  cursor: pointer;
  width: 50%;
`;
